<template>
  <v-select-driver v-if="showSelect"
                   :company="company"
                   :value="driverId"
                   :loading="updatingDriver"
                   :label="label"
                   @change="selectDriver(load.humanId, $event)">
  </v-select-driver>
</template>

<script>
import { mapGetters } from 'vuex';

import API from '@/api';

import bookedLoadMixin from '@/mixins/bookedLoadMixin';
import * as Checks from '@/store/permissions';
import * as Loads from '@/types/models/load';
import { driversWithCDN } from '@/types/models/company';

import VSelectDriver from './SelectDriver';

export default {
  name: 'VSelectLoadDriver',
  components: {
    VSelectDriver,
  },
  props: {
    load: {
      type: Object,
    },
    company: {
      type: Object,
    },
    label: {
      type: String,
    },
  },
  data() {
    return {
      updatingDriver: false,
    };
  },
  mixins: [
    bookedLoadMixin,
  ],
  computed: {
    ...mapGetters('profiles', ['isLtnAdmin']),
    drivers() {
      return driversWithCDN(this.company);
    },
    showSelect() {
      return this.isMyLoad && this.drivers.length &&
         this.hasOfficePermission(Loads.carrierCompany(this.load).id);
    },
    driverId() {
      return Loads.assignedTruckingCompanyDriverUserId(this.load);
    },
    isMyLoad() {
      const carrier = this.bookedLoadCarrierCompany((this.load));
      return carrier && this.company.id === carrier.id;
    },
  },
  methods: {
    ...mapGetters('profiles', {
      findCompanyAccount: 'findCompanyAccount',
    }),
    async selectDriver(loadId, driverId) {
      try {
        this.updatingDriver = true;
        const apiResponse = await API.load.assignDriver({ loadId, driverId });
        this.$store.dispatch('applications/setSuccessNotification', {
          message: 'Assigned.',
        });
        this.$emit('refresh', apiResponse.data);
      } catch (error) {
        this.$store.dispatch('applications/setErrorNotification', {
          message: 'Something went wrong assigning this driver',
        });
      } finally {
        this.updatingDriver = false;
      }
    },
    hasOfficePermission(companyId) {
      const companyAccount = this.findCompanyAccount()(companyId);
      return this.isLtnAdmin || Checks.accountHasOfficePermission(companyAccount);
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/SelectLoadDriver.vue